import { render } from "./PermissionsView.vue?vue&type=template&id=0bd00a52&scoped=true"
import script from "./PermissionsView.vue?vue&type=script&lang=js"
export * from "./PermissionsView.vue?vue&type=script&lang=js"

import "./PermissionsView.vue?vue&type=style&index=0&id=0bd00a52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd00a52"]])

export default __exports__